import getApiInstance from '@/services/Api.ts'
import { AxiosResponse } from 'axios'
import { ref } from 'vue'
import { useLocalStorage } from '@vueuse/core'

const api = getApiInstance()

export type Product = {
  id: string
  name: string
  description: string
}

export type Price = {
  id: string
  amount: number
  currency: string
  interval: string
}

export type Whitelabel = {
  id: number
  name: string
  identifier: string
}

export type PlanTier = {
  tier: string
  value_tier: 'basic' | 'plus' | string
  product: Product
  price: Price
  whitelabel: Whitelabel
}

export type TiersResponse = {
  tiers: PlanTier[]
}

export function useTieredPlan() {
  const storedTiers = useLocalStorage<PlanTier[]>('cachedTiers', [])
  const tiers = ref<PlanTier[]>(storedTiers.value)
  const error = ref<string | null>(null)
  const loading = ref<boolean>(false)
  const selectedPlan = useLocalStorage<string | null>('selectedPlan', null)

  const fetchTieredPlans = async () => {
    if (tiers.value.length > 0) {
      return
    }
    loading.value = true
    try {
      const res = (await api.Get('/v3/payment/plan-tiers')) as AxiosResponse<TiersResponse>
      tiers.value = res.data?.tiers || []
      storedTiers.value = tiers.value
      error.value = null
    } catch (err: any) {
      tiers.value = []
      error.value = err.response?.data?.message || 'Failed to fetch tiered plans'
    } finally {
      loading.value = false
    }
  }

  const setSelectedPlan = (plan: 'free' | 'monthly' | 'annual' | string) => {
    selectedPlan.value = plan
  }

  const clearSelectedPlan = () => {
    selectedPlan.value = null
  }


  return {
    tiers,
    error,
    loading,
    fetchTieredPlans,
    selectedPlan,
    setSelectedPlan,
    clearSelectedPlan,
  }
}
